<template>
    <div class="uploader-wrapper">
        <span class="caption ft-xbld" v-if="caption">{{ caption }}</span>
        <div class="dropzone" :class="[hover? 'hover' : '']" 
            @drop.prevent="onDrop"
            @click.prevent="onClick"
            @dragenter.prevent="onDragEnter"
            @dragleave.prevent="onDragLeave"
        >
            <!-- Preview Containers -->
            <div class="preview-container" 
                :style="{backgroundImage: 'url('+previewSrc+')'}"
                v-if="previewSrc && this.type === 'image'"
            ></div>
            <div class="preview-container" 
                v-if="previewSrc && this.type === 'video'"
            >
                <video :src="previewSrc" width="100%" autoplay muted loop></video>
            </div>

            <!-- Clear Button -->
            <div class="clear" v-if="previewSrc && !customClear" @click.prevent.stop="onClear">+</div>
            <span class="clear" v-else-if="previewSrc && customClear" @click.prevent.stop="onClear">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2H16.5C17.3284 2 18 2.67157 18 3.5C18 4.32843 17.3284 5 16.5 5H16V16C16 17.6569 14.6569 19 13 19H5C3.34315 19 2 17.6569 2 16V5H1.5C0.671573 5 0 4.32843 0 3.5C0 2.67157 0.671573 2 1.5 2H5C5 0.895431 5.89543 0 7 0H11C12.1046 0 13 0.895431 13 2ZM5 14.5C5 15.3284 5.67157 16 6.5 16C7.32843 16 8 15.3284 8 14.5V8.5C8 7.67157 7.32843 7 6.5 7C5.67157 7 5 7.67157 5 8.5V14.5ZM11.5 16C10.6716 16 10 15.3284 10 14.5V8.5C10 7.67157 10.6716 7 11.5 7C12.3284 7 13 7.67157 13 8.5V14.5C13 15.3284 12.3284 16 11.5 16Z" fill="white"/>
                </svg>
            </span>

            <!-- Placeholder -->
            <div class="placeholder" v-else>
                <span class="ico"></span>
                <p class="txt ft-bld" v-if="customCaption">{{ customCaption }}</p>
                <p class="txt ft-bld" v-else>Drag & drop a file or choose from your desktop</p>
            </div>
        </div>
        <input type="file" ref="inputFile" @change="onInputFileChange" v-show="false">
    </div>
</template>

<script>
const events = ['dragenter', 'dragover', 'dragleave', 'drop']
export default {

    props: {
        type: {
            default: 'image',
            type: String
        },
        caption: {
            default: "Caption",
            type: String
        },
        customClear: {
            default: false,
            type: Boolean
        },
        customCaption: {
            default: '',
            type: String
        }
    },

    data() {
        return {
            currentFile: null,
            previewSrc: null,
            hover: false,
            hoverCount: 0
        }
    },

    methods: {

        async addFile(file) {
            if (!file){ return }
            if (!file.type.startsWith(this.type + '/')){ return }

            this.currentFile = file
            this.setPreviewSrc(await this.fileToBase64(file))
            this.refreshInputValue()
        },

        setPreviewSrc(src) {
            this.previewSrc = src
            this.$emit("preview-change", this.previewSrc)
        },

        refreshInputValue() {

            if(!this.currentFile) {
                return this.$emit("input", null)    
            }

            this.$emit("input", {
                file: this.currentFile,
                previewSrc: this.previewSrc
            })
        },

        clearPreviewSrc() {
            this.setPreviewSrc(null)
        },

        onDrop(e) {
            this.hover = false
            this.hoverCount = 0
            this.addFile(e.dataTransfer.files[0])
        },

        onDragEnter(e) {
            this.hoverCount++
            this.hover = true
        },

        onDragLeave(e) {
            this.hoverCount--
            if(this.hoverCount === 0) {
                this.hover = false
            }
        },

        onClick() {
            this.$refs.inputFile.click()
        },

        onInputFileChange(e) {
            this.addFile(e.target.files[0])
        },

        onClear() {
            this.$refs.inputFile.value = null
            this.currentFile = null
            this.previewSrc = null

            this.refreshInputValue()
            this.$emit("preview-change", null)
        },

        fileToBase64(file) {
            return new Promise((resolve) => {
                let reader = new FileReader()
                reader.onload = () => resolve(reader.result)

                reader.addEventListener('progress', (e) => {
                    console.log(e)
                });

                reader.addEventListener('error', (e) => {
                    console.log(e)
                });
                
                reader.readAsDataURL(file)
            })
        },

        preventDefaults(e) {
            e.preventDefault()
        }
    },

    created() {
        events.forEach((eventName) => {
            document.body.addEventListener(eventName, this.preventDefaults)
        })
    },

    destroyed() {
        events.forEach((eventName) => {
            document.body.removeEventListener(eventName, this.preventDefaults)
        })
    }
}
</script>